import { GetInformAPI, AddInformAPI, DelInformAPI, EditInformAPI, PutInformAPI } from '@/api/inform'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取资讯管理
    async getinform({ commit }, item) {
      const res = await GetInformAPI(item)
      return res
    },
    // 添加资讯管理
    async addinform({ commit }, item) {
      await AddInformAPI(item)
    },
    // 删除资讯管理
    async delinform({ commit }, id) {
      await DelInformAPI(id)
    },
    // 获取资讯详情
    async editinform({ commit }, id) {
      const res = await EditInformAPI(id)
      return res
    },
    // 修改资讯详情
    async putinform({ commit }, item) {
      await PutInformAPI(item)
    }
  }
}
